<template>
  <div>
    <!--<header class="header divflex">-->
      <!--&lt;!&ndash;<a href="index.html" class="backlastpage"></a>&ndash;&gt;-->
      <!--<h3 v-on:click="backHistory">< 编辑在线简历</h3>-->
    <!--</header>-->
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">编辑个人简历</span>
      </p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
  <div style="width: 90%;margin: 50px auto 0">
 <!--<header><span v-on:click="backHistory"><</span>编辑在线简历</header>-->
    <router-link to="/information">
      <div class="editHeader">
        <div class="editHeaderLeft">
          <h3>{{list.name}}</h3>
          <!--<p>10年经验/26岁/本科</p>-->
          <p v-if="list.workinghours||list.age" class="age" >
            {{list.workinghours+'年/'+list.age+'岁/'}}
          </p>
          <p v-else class="age" style="color: #f56723">
          请完善个人资料
        </p>
        </div>
        <div class="editHeadeRight">
          <!--<img v-if="list.photo" class="editHeaderImg" :src="list.photo" alt="">-->
          <img v-if="list.photo" class="editHeaderImg" :src="list.photo" alt="">
          <img v-else class="editHeaderImg" src="@/assets/img/tx.jpg" alt="">
          <!--{{list.photo}}-->
          <!--<img class="editHeaderImg" src="@/assets/img/tx.jpg" alt="">-->
        </div>
      </div>
    </router-link>

    <div class="edit" @click="getJobWantedId(list.id)">
      <!--<router-link to="/jobWanted">-->
        <h3 >求职意向</h3>
      <!--</router-link>-->
      <p v-if="job">{{job.expectposition+qwxz}}</p>
      <p v-else >请填写求职意向</p>
      <p v-if="status">{{status}}</p>
    </div>
    <div class="edit" >
      <router-link  to="/editPersonal">
        <div class="addEdit">
          <h3>个人优势</h3>
          <p><van-icon name="add-o" /></p>
        </div>
        <div v-if="list">{{list.introduction}}</div>
      </router-link>
    </div>
    <div class="edit" >
      <!--<router-link  :to="{name:'addWork',params:{id:list.id}}">-->
      <!--<router-link   @click="getDescribe(list.id)">-->

      <!--<router-link :to="{name:'Log',params:{num:666}}">显示登录页面</router-link>-->
        <div class="addEdit" @click="toAddwork(list.id)">
          <h3>工作经历</h3>
          <p><van-icon name="add-o" /></p>
        </div>
        <!--</router-link>-->

      <div v-if="list" v-for="(index,key) in list.workexperience" @click="getDescribe(index.id)">
        <!--<router-link  :to="{name:'editWork',params:{id:index.id}}">-->
        <!--{{index.id}}-->
        <h3>{{index.name}}</h3>
        <p>{{index.positionname}}</p>
        <p>{{index.entrytime+'--'+index.resigntime}}</p>
        <p>{{index.workdescription}}</p>
        <!--</router-link>-->
      </div>

    </div>
    <div class="edit" >
      <router-link   :to="{name:'addEducation',params:{id:list.id}}">
        <div class="addEdit">
          <h3>教育经历</h3>
          <p><van-icon name="add-o" /></p>
        </div>
      </router-link>
      <div v-if="list" v-for="(index,key) in list.school">
        <router-link  :to="{name:'editEducation',params:{id:index.id}}">
        <h3>{{index.name}}</h3>
        <p>{{index.major}}</p>
        <p>{{index.schoolstart+"--"+index.schoolstart}}</p>
        </router-link>
      </div>
    </div>
    <div class="edit"  >
      <router-link  to="/addProject">
        <div class="addEdit">
          <h3>项目经历</h3>
          <p><van-icon name="add-o" /></p>
        </div>
      </router-link>
      <!--<h3>项目经历</h3>-->
      <div v-if="list" v-for="(index,key) in list.projectexperience" @click="sendEditProject(index.id)">
        <h3>{{index.proname}}</h3>
        <p>{{index.starttime+"--"+index.endtime}}</p>
        <p>{{index.prodescription}}</p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  export default {
    name: 'edit',
    data () {
      return {
        msg: '',
        job:{
          expectposition:''
        },
        a:1,
        list:{
//          0:{
//            jobintention:{
//              0:{}
//            }

//      0: {id: 9, resumeid: 7, expectposition: "java", },
//      1: {id: 10, resumeid: 7, expectposition:}

//          }
        },
        qwxz:"",
        status:""
      }
    },
    mounted(){
     this.resumeMessage()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toAddwork(id){
        this.$router.push({
          path: `/addWork/${id}`
        })
      },
      getDescribe(id){
         this.$router.push({
           path: `/editWork/${id}`
         })
      },
      sendEditProject(id){
        this.$router.push({
          path: `/editProject/${id}`
        })
      },
      getJobWantedId(id){
        this.$router.push({
//          path: `/jobWanted/${id}`
          path: "/jobWanted",
          query:{
            id:id
          }
        })
      },
//      getJobWantedId(id){
//        this.$router.push({
////          path: `/jobWanted/${id}`
//          path: `/jobWanted`
//        })
//      },
      resumeMessage() {
        this.$api.obtainMy({'userid':localStorage.getItem("userid")}).then(res=>{

//          this.list=res.data
          this.list=res.data?res.data[0]:{}
          this.job=res.data[0].jobintention ?res.data[0].jobintention[0]:{}
          console.log(this.list)
//          var qwxz=""
          switch (res.data[0]['jobintention'][0]['expectsalary']){
            case 1:
              this.qwxz = '1K-2K';
              break;
            case 2:
              this.qwxz = '2K-4K';
              break;
            case 3:
              this.qwxz = '4K-6K';
              break;
            case 4:
              this.qwxz = '6K-8K';
              break;
            case 5:
              this.qwxz = '8K-10K';
              break;
            case 6:
              this.qwxz = '10K-15K';
              break;
            case 7:
              this.qwxz = '15K-20K';
              break;
            case 8:
              this.qwxz = '20K-25K';
              break;
            case 9:
              this.qwxz = '25K-35K';
              break;
            case 10:
              this.qwxz = '35K-50K';
              break;
            case 11:
              this.qwxz = '50K-70K';
              break;
            case 12:
              this.qwxz = '70K-100K';
              break;
            case 13:
              this.qwxz = '100K以上';
              break;
            default:
              this.qwxz = '';
              break;
          }
          switch (res.data[0].jobstatus){
            case 1:
              this.status='离职随时到岗';
            case 2:
              this.status='在职月内到岗';
            case 3:
              this.status='在职考虑机会';
            case 4:
              this.status='在职暂不考虑';
            default:
              this.status='离职随时到岗';
          }
          console.log(qwxz)
        }).catch(err=>{

        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  /*@import '../assets/css/common.css';*/
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  *{
    /*font-family: '微软雅黑 Regular', '微软雅黑';*/
    /*font-family: "Adobe 宋体 Std L";*/
    /*font-family: "Helvetica Neue", "Helvetica", "Arial", "sans-serif";*/
  }
  .addEdit{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /*.header {*/
    /*width: 100%;*/
    /*height: 40px;*/
    /*!*height: 45px;*!*/
    /*!*background-color: rgba(0,152,217,.4);*!*/
    /*background-color: #6e9bcf;*/
    /*color: #fff;*/
    /*align-items: center;*/
    /*position: fixed;*/
    /*top: 0;*/
    /*left: 0;*/
    /*z-index: 2;*/
  /*}*/
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .divflex {
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
  }
  .editHeadeRight{
   width: 80px;
    height: 80px;
  }
  .editHeader{
    width: 100%;
    height: 100%;
    padding-top: 40px;
  }
  .editHeader{
    display: flex;
    /*justify-content:center;*/
    justify-content:space-between;;
    flex-direction:row;
    align-items: center;
  }
  .editHeaderImg{
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  .edit{
    border-bottom: 1px solid #EAEAEA;
  }

</style>



// WEBPACK FOOTER //
// src/components/editResume.vue